// @ts-check
// if ratio is `1:20,000` input is `20`
export const diluteLocalsRatio = (input, strength) =>
  Math.round(1 / ((1 / (input * 1000)) * strength)) / 1000
